module.exports = __webpack_public_path__ + "media/app/img/github-sign-8493a6d5b252df41924a407f7650f9da.png";